import React, {useState, useRef, useEffect} from 'react';
import './../styles.css';
import './../../../assets/styles/styles.css';
import {Link} from 'react-router-dom';
import Select from "react-select";
import {useDispatch, useSelector} from 'react-redux';
import {requestSensitiveRegionsInitiatives, setInitiativeClicked} from './../../../actions/initiativeActions';
import {useHistory} from "react-router-dom";
import {setPathRq} from './../../../actions/initiativeActions';
import Swal from 'sweetalert2';

function MapInfoPanel({mainConfig, itemOver}){
    
    const history = useHistory();
    const dispatch = useDispatch();
    const config = mainConfig? mainConfig: 
    {
        jsonPaths:[], 
        scale:5
    };
    const listLabel = useRef(null);
    //const  = useRef("");
    const {jsonPaths} = config;
    const regionSelected = itemOver.regionSelected;
    const pathSelected = itemOver.pathSelected;
    const [initiativesSensitive, svinitiativesSensitive] = useState([]);
    let sensitiveFindTrigger;
    let validEntry;

    //TODO: Mejorar evento de scroll para full precision de sube y baja.

    useEffect(() => {
        document.getElementById("router").addEventListener('scroll', scroll);
        if(document.getElementById("router").scrollTop >= 78){
            listLabel.current.style.top = "10px";
        }else{
            listLabel.current.style.top = "90px";
        }

        return () => {
            document.getElementById("router").removeEventListener('scroll', scroll);
        }
    }); 
    
    const scroll = () => {
        if(document.getElementById("router").scrollTop <= 78){
            listLabel.current.style.top = 90 - document.getElementById("router").scrollTop + "px";
        }else{
            listLabel.current.style.top = "10px";
        }
    }

    const defineStyles = (parent, path, type) => {
        let priority = path.id === pathSelected? "Primary": parent.id === regionSelected? "Secondary": false;
        if(priority === "Primary"){
            switch (type){
                case "paragraphPoint":
                    return {
                        background: "white"
                    }
                case "cont-box-list":
                    return {
                        background: config.colorPath.primary
                    }
                case "paragraphText":
                    return {
                        color: "white",
                        textDecoration:"underline"
                    }
                default:
                    return {};
            }
        }else if(priority === "Secondary"){
            switch (type){
                case "paragraphPoint":
                    return {
                        background: "white"
                    }
                case "paragraphText":
                    return {
                        color: "white"
                    }
                    case "cont-box-list":
                    return {
                        background: config.colorPath.secondary
                    }
                default:
                    return {};
            }
        }   
        return {};
    }

    const cbRequestSensitive = (data) => {
        let dat = data.map(item => {
            return {
                ...item,
                label: `${item.nameMicroRegion} - ${item.description}`
            }
        });
        svinitiativesSensitive(dat);
    }

    const handleChangeSensitive = (item) => {
        dispatch(setInitiativeClicked(item));
        let region = jsonPaths.find(region => {
            return region.id === parseInt(item.idMicroRegion);
        });
        dispatch(setPathRq(region));
        history.push("/iniciativa/formulario1/formulario2/");
    }

    const inputSelectChange = (value) => {
        validEntry = true;
        if(validEntry){
            clearInterval(sensitiveFindTrigger);
            sensitiveFindTrigger = setTimeout(() => {
                let data = {
                    termino: value
                };
                dispatch(requestSensitiveRegionsInitiatives(data, cbRequestSensitive));
            }, 500);
        }
    }

    return (
        <div>
            <div className="ListLabel" ref={listLabel}>
                <div className="row mt-2 justify-content-center" style={{flexGrow:1}}>
                    {/*<div className="bt-1" style={{width:200}}>Buscar Iniciativa</div>*/}
                    {/*<div style={{width:300}}>
                        <Select onInputChange={(event)=> inputSelectChange(event)} placeholder="Buscar Iniciativa..." options={initiativesSensitive} onChange={(item) => handleChangeSensitive(item)} />
                    </div>*/}
                </div>
                    <div className="row m-0">
                    {
                        jsonPaths.map(parentItem => {
                            let parent = parentItem;
                            return (
                                <div key={parent.id} className="col-6 p-2">
                                    <div style={{textAlign:"center", fontWeight:"bold"}}>
                                        {`MICRO REGION ${parent.subRegionName}`}
                                    </div>
                                    <div className="row m-0">
                                        {
                                            parent.paths.map(path => {
                                                return <Link style={defineStyles(parent, path, "cont-box-list")} to={"/iniciativa/formulario1/"} className="col-6 p-1" key={path.id} onMouseEnter={() => config.overPath({
                                                    ...parent,
                                                    pathSelected:path.id
                                                })} onMouseLeave={() => config.leavePath()} onClick={() => {
                                                        config.clickPath(parent);
                                                        localStorage.removeItem('currentPageInitiative');
                                                    }}>
                                                    <div className="row m-0 align-items-center" style={{cursor:"pointer"}}>
                                                        <div className="paragraphPoint" style={defineStyles(parent, path, "paragraphPoint")}></div>
                                                        <div className="paragraphText" style={defineStyles(parent, path, "paragraphText")}>{path.name}</div>
                                                    </div>
                                                </Link>
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default MapInfoPanel;